import style from './Toast.css';
import Button from '../Button/Button';
import { renderIf } from '../../../utils/render.utils';
import CrossIcon from '../Icons/CrossIcon';
import { useEffect } from 'preact/hooks';
import { _className } from '../../../utils/classname.utils';

const Toastype = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
};

export default function Toast({
  className = '',
  type = Toastype.INFO,
  floating = false,
  autoDismiss = false,
  showing = false,
  message = '',
  buttonText = '',
  textAlign = 'center',
  onButtonClick,
  onCloseClick,
  onHide,
}) {
  useEffect(() => {
    if (autoDismiss && showing) {
      setTimeout(() => {
        if (onHide) onHide();
      }, Toast.Delay);
    }
  }, [showing]);
  return (
    <div
      className={`${className} ${style.toast} ${style[type]} ${_className(
        floating,
        style.floating,
      )} ${_className(!showing, style.hidden)} ${_className(
        showing,
        style['auto-hide'],
      )}`}
    >
      <div className={style['toast-text']} style={{ textAlign: textAlign }}>
        {message}
      </div>

      {renderIf(
        !!onButtonClick,
        <Button
          className={style['toast-button']}
          type={Button.Type.TERTIARY}
          size={Button.Size.SMALL}
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>,
      )}

      {renderIf(
        !!onCloseClick,
        <div className={style['toast-close']} onClick={onCloseClick}>
          <CrossIcon width={16} height={16} />
        </div>,
      )}
    </div>
  );
}

Toast.Type = Toastype;
Toast.Delay = 3000;
